import { mountHTTPInstance } from '@ghq-abi/auth-client-lib/client';

export const API_VERSION = 'v1';

export const iappApiV1 = mountHTTPInstance({
  baseURL: `${process.env.NEXT_PUBLIC_IAPP_API_URL}/${API_VERSION}`
});
